<template>
  <v-app>
    <v-main>
      <table-page
        :headers="headers"
        :items="collectionProtocolEventUnitOfMeasurements"
      />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getCollectionProtocolEventUnitOfMeasurements"]),
  },
  created() {
    this.$store.commit("setSearchTerm", "");
    this.getCollectionProtocolEventUnitOfMeasurements();
  },
  computed: {
    ...mapGetters([
      "currentInstitution",
      "collectionProtocolEventUnitOfMeasurements",
    ]),
  },
  data() {
    return {
      headers: [
        {
          text: "Unit Name",
          align: "start",
          value: "unitName",
        },
        { text: "Unit Symbol", value: "unitSymbol" },
        { text: "Description", value: "description" },
        { text: "To Minute Conversion Rate", value: "toMinuteConversionRate" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>